import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {FormControl} from '@angular/forms';

import {ILinkShare, LinkShareModalService} from './link-share-modal.service';
import {EventService} from '@src/app/core/services/event.service';
import {catchError, finalize} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {GlobalEventsService} from '@src/app/services/global-events.service';

@Component({
  selector: 'app-link-share-modal',
  templateUrl: './link-share-modal.component.html',
  styleUrls: ['./link-share-modal.component.scss'],
})
export class LinkShareModalComponent implements OnInit {
  passwordControl: FormControl = new FormControl();
  linkShare: ILinkShare;
  error: string;
  busy: boolean;

  constructor(
    private cdr: ChangeDetectorRef,
    private linkShareModalService: LinkShareModalService,
    private eventService: EventService,
    private notification: GlobalEventsService
  ) {}

  ngOnInit(): void {
    this.linkShareModalService
      .get(this.eventService.eventId)
      .subscribe((linkShare: ILinkShare) => {
        this.linkShare = linkShare;
        this.passwordControl.setValue(linkShare.password);
        this.cdr.detectChanges();
      });
  }

  save(): void {
    this.busy = true;
    this.error = undefined;

    this.linkShareModalService
      .save(this.eventService.eventId, this.passwordControl.value)
      .pipe(
        catchError((errorResponse: HttpErrorResponse) => {
          this.error = errorResponse.error.message;
          throw errorResponse;
        }),
        finalize(() => {
          this.busy = false;
          this.cdr.detectChanges();
        })
      )
      .subscribe((linkShare: ILinkShare) => {
        this.linkShare = linkShare;

        // Copy link to clipboard
        this.copy();
      });
  }

  delete(): void {
    if (
      !confirm('Are you sure you want to delete this view-only shareable link?')
    ) {
      return;
    }

    this.busy = true;
    this.error = undefined;
    this.linkShareModalService
      .delete(this.eventService.eventId)
      .pipe(
        finalize(() => {
          this.busy = false;
          this.cdr.detectChanges();
        })
      )
      .subscribe(() => {
        this.linkShare = undefined;
        this.passwordControl.reset();

        this.notification.ToastNotificationEvent.emit({
          message: 'Link has been deleted.',
          autoHideDelay: 2000,
          title: 'Successfully Deleted',
          classes: ['notification'],
        });
      });
  }

  copy(): void {
    navigator.clipboard.writeText(this.linkShare.link).then(() => {
      this.notification.ToastNotificationEvent.emit({
        message: 'Link copied to clipboard.',
        autoHideDelay: 2000,
        title: 'Successfully Created',
        classes: ['notification'],
      });
    });
  }
}
